<template>
  <div v-if="!!tab">
    <l-option-selector
      v-if="!isMobile"
      :model-value="effectiveOrderingMode"
      :options="listOptions"
      class="w-48"
      @update:model-value="setListSelected"
    />
    <l-option-selector
      v-else
      :model-value="effectiveOrderingMode"
      :options="mobileListOptions"
      class="w-32"
      @update:model-value="setListSelected"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { Option } from '@last/core-ui/paprika'
import { LOptionSelector } from '@last/core-ui/paprika'
import type { OptionValue } from '@last/core-ui/paprika/components/LOptionSelector.vue'

import { useTabs } from '@/composables/useTabs'
import { useConfigStore } from '@/store/config'
import { useTabsStore } from '@/store/tabs'
import type { OrderingMode } from '@/types'
import { isMobile } from '@/utils/device-type'

type Props = {
  tabId: string
}

const props = defineProps<Props>()

const { t } = useI18n()

const tabsStore = useTabsStore()
const configStore = useConfigStore()

const { updateTabOrdering } = tabsStore
const { tab } = useTabs(() => props.tabId)

const effectiveOrderingMode = computed(() => {
  return tab.value?.orderingMode ?? configStore.config.tabOrdering ?? 'seats'
})

const listOptions = [
  { label: t('tabs.seats'), value: 'seats' },
  { label: t('tabs.courses'), value: 'courses' }
]

const mobileListOptions: Option[] = [
  { icon: 'chair', value: 'seats' },
  { icon: 'list', value: 'courses' }
]

function setListSelected(option?: OptionValue) {
  if (!option) return
  updateTabOrdering({
    tabId: props.tabId,
    orderingMode: option as OrderingMode
  })
}
</script>
